import type { TMapOptions } from '~/misc/map/types';
import { EGoogleMapTypeId } from '~/misc/v-map/types';
import { mapLibConfigInjectionKey } from 'homesearch-vue-common/dist/components/v-map';

const googleMapIdInjectionKey = Symbol('googleMapIdInjectionKey');

const DEFAULT_MAP_OPTIONS: TMapOptions = {
  zoom: 8,
  disableDefaultUI: true,
  scrollwheel: true,
  mapTypeId: EGoogleMapTypeId.ROADMAP,
  minZoom: undefined,
};

export { mapLibConfigInjectionKey, googleMapIdInjectionKey, DEFAULT_MAP_OPTIONS };
